import React from 'react';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import classes from './ClientStep.module.scss';
import { useWindowSize } from '../../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../../utils/constants';
import { generalEnums } from '../../../../../utils/enums';

const autocompleteStyles = {
  '& .MuiSvgIcon-root': {
    color: '#D1D3D4',
    fontSize: '24px'
  },
  '& .MuiFormControl-fullWidth': {
    width: '100%'
  }
};

const textFieldStyles = (width) => ({
  width,
  backgroundColor: 'white',
  borderRadius: '10px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #D1D3D4',
    borderRadius: '10px'
  },
  color: '#283237',
  fontSize: '16px',
  fontWeight: '325',
  lineHeight: '19px',
  fieldset: {
    legend: {
      width: 'unset'
    }
  }
});

export default function ClientStep({
  type,
  clients,
  client,
  setClient,
  description,
  setDescription,
  titles,
  title,
  setTitle,
  error,
  extraComponent,
  wrapperContainer
}) {
  const { t } = useTranslation();
  const size = useWindowSize();
  const wrapperClassForMobile = `${classes.filedsContainer} ${wrapperContainer}`;

  return (
    <div className={classes.fullWidth}>
      <div className={classes.container}>
        <p className={classes.text}>{t('dashboard.createtimesheet.steps.selectworkdetails')}</p>
        {type === generalEnums.EXPENSE && size.width > responsiveSizeTimesheet && (
          <div className={classes.filedsContainer}>
            <TextField
              placeholder={`${t('dashboard.createclaim.steps.claimdescription')}*`}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              sx={textFieldStyles('100%')}
            />
          </div>
        )}
        <div className={size.width > responsiveSizeTimesheet ? classes.filedsContainer : wrapperClassForMobile}>
          {type === generalEnums.EXPENSE && size.width < responsiveSizeTimesheet && (
            <div className={classes.filedsContainer}>
              <TextField
                placeholder={`${t('dashboard.createclaim.steps.claimdescription')}*`}
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                sx={textFieldStyles('100%')}
              />
            </div>
          )}
          <Autocomplete
            disableClearable
            value={client}
            options={clients}
            sx={{ ...autocompleteStyles, width: '100%' }}
            popupIcon={<ExpandMoreIcon />}
            forcePopupIcon
            onChange={(event, newValue) => {
              setClient(newValue.label);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={`${t('dashboard.createtimesheet.steps.clientname')}*`}
                sx={textFieldStyles(size.width > responsiveSizeTimesheet ? '242px' : '300px')}
              />
            )}
          />
          <Autocomplete
            disabled={!client || titles.length < 1}
            disableClearable
            value={title}
            options={titles}
            sx={{ ...autocompleteStyles, width: '100%' }}
            popupIcon={<ExpandMoreIcon />}
            forcePopupIcon
            getOptionLabel={(option) => option.JobTitle || ''}
            renderOption={(props, option) => (
              <li {...props} key={option.Id}>
                {option.JobTitle}
              </li>
            )}
            onChange={(event, newValue) => {
              setTitle(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={`${t('dashboard.createtimesheet.steps.titlename')}*`}
                sx={textFieldStyles(size.width > responsiveSizeTimesheet ? '242px' : '300px')}
              />
            )}
          />
        </div>

        {size.width > responsiveSizeTimesheet && error && <p className={classes.error}>{error}</p>}
        {size.width > responsiveSizeTimesheet && !error && <p className={classes.error}>&nbsp;</p>}
      </div>
      <div>{extraComponent ? <div className={classes.extraComponent}>{extraComponent}</div> : null}</div>
    </div>
  );
}
